var $b63be9b0371e788c$exports = {};
"use strict";
// ============================================
// Configuration & Constants
// ============================================
const $b63be9b0371e788c$var$CONFIG = {
    PASSWORD_LENGTH: {
        MIN: 0,
        MAX: 16,
        DEFAULT: 0
    },
    STRENGTH_THRESHOLDS: {
        TOO_WEAK: {
            min: 1,
            max: 4
        },
        WEAK: {
            min: 5,
            max: 8
        },
        MEDIUM: {
            min: 9,
            max: 12
        },
        STRONG: {
            min: 13,
            max: 16
        }
    },
    COPIED_MESSAGE_DURATION: 700
};
const $b63be9b0371e788c$var$CHARACTERS = {
    uppercase: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
    lowercase: "abcdefghijklmnopqrstuvwxyz",
    numbers: "0123456789",
    symbols: "!@#$%^&*()_+-=[]{}|;:,.<>?"
};
const $b63be9b0371e788c$var$CSS_CLASSES = {
    hidden: "hidden",
    emptyEvalBox: [
        "border-grey-200",
        "bg-grey-850"
    ],
    fullEvalBoxTooWeak: [
        "border-red-500",
        "bg-red-500"
    ],
    fullEvalBoxWeak: [
        "border-orange-400",
        "bg-orange-400"
    ],
    fullEvalBoxMedium: [
        "border-yellow-300",
        "bg-yellow-300"
    ],
    fullEvalBoxStrong: [
        "border-green-300",
        "bg-green-300"
    ]
};
const $b63be9b0371e788c$var$STRENGTH_LABELS = {
    TOO_WEAK: "too weak!",
    WEAK: "weak",
    MEDIUM: "medium",
    STRONG: "strong"
};
// ============================================
// DOM Elements Cache
// ============================================
const $b63be9b0371e788c$var$elements = {
    passwordNum: document.getElementById("password-number"),
    optionError: document.getElementById("select-option-error"),
    copiedText: document.getElementById("copied"),
    copyImage: document.getElementById("copy-image"),
    lengthOutput: document.getElementById("length-output"),
    lengthInput: document.getElementById("length-input"),
    checkboxes: {
        all: document.querySelectorAll(".checkbox"),
        uppercase: document.getElementById("uppercase-checkbox"),
        lowercase: document.getElementById("lowercase-checkbox"),
        numbers: document.getElementById("numbers-checkbox"),
        symbols: document.getElementById("symbols-checkbox")
    },
    strengthEvaluationText: document.getElementById("strength-evaluation"),
    evaluationBoxes: {
        all: document.querySelectorAll(".evaluation-box"),
        box1: document.getElementById("evaluation-box-1"),
        box2: document.getElementById("evaluation-box-2"),
        box3: document.getElementById("evaluation-box-3"),
        box4: document.getElementById("evaluation-box-4")
    },
    generateButton: document.getElementById("generate-button")
};
// ============================================
// State Management
// ============================================
const $b63be9b0371e788c$var$state = {
    currentPassword: "",
    copiedTimeoutId: null
};
// ============================================
// Utility Functions
// ============================================
/**
 * Validates that all required DOM elements exist
 * @throws {Error} If any required element is missing
 */ const $b63be9b0371e788c$var$validateDOMElements = ()=>{
    const requiredElements = [
        "passwordNum",
        "lengthInput",
        "lengthOutput",
        "generateButton"
    ];
    requiredElements.forEach((key)=>{
        if (!$b63be9b0371e788c$var$elements[key]) throw new Error(`Required DOM element not found: ${key}`);
    });
};
/**
 * Generates cryptographically secure random password
 * @param {number} length - Password length
 * @param {string} characterPool - Available characters
 * @returns {string} Generated password
 */ const $b63be9b0371e788c$var$generateSecurePassword = (length, characterPool)=>{
    if (!characterPool || characterPool.length === 0) throw new Error("Character pool cannot be empty");
    const password = [];
    const poolLength = characterPool.length;
    // Use crypto.getRandomValues for cryptographically secure randomness
    const randomValues = new Uint32Array(length);
    crypto.getRandomValues(randomValues);
    for(let i = 0; i < length; i++){
        const randomIndex = randomValues[i] % poolLength;
        password.push(characterPool[randomIndex]);
    }
    return password.join("");
};
/**
 * Builds character pool based on selected checkboxes
 * @returns {string} Character pool
 */ const $b63be9b0371e788c$var$buildCharacterPool = ()=>{
    let pool = "";
    if ($b63be9b0371e788c$var$elements.checkboxes.uppercase.checked) pool += $b63be9b0371e788c$var$CHARACTERS.uppercase;
    if ($b63be9b0371e788c$var$elements.checkboxes.lowercase.checked) pool += $b63be9b0371e788c$var$CHARACTERS.lowercase;
    if ($b63be9b0371e788c$var$elements.checkboxes.numbers.checked) pool += $b63be9b0371e788c$var$CHARACTERS.numbers;
    if ($b63be9b0371e788c$var$elements.checkboxes.symbols.checked) pool += $b63be9b0371e788c$var$CHARACTERS.symbols;
    return pool;
};
/**
 * Determines password strength based on length
 * @param {number} length - Password length
 * @returns {string|null} Strength label or null if length is 0
 */ const $b63be9b0371e788c$var$getPasswordStrength = (length)=>{
    if (length === 0) return null;
    const { TOO_WEAK: TOO_WEAK, WEAK: WEAK, MEDIUM: MEDIUM, STRONG: STRONG } = $b63be9b0371e788c$var$CONFIG.STRENGTH_THRESHOLDS;
    if (length >= TOO_WEAK.min && length <= TOO_WEAK.max) return $b63be9b0371e788c$var$STRENGTH_LABELS.TOO_WEAK;
    if (length >= WEAK.min && length <= WEAK.max) return $b63be9b0371e788c$var$STRENGTH_LABELS.WEAK;
    if (length >= MEDIUM.min && length <= MEDIUM.max) return $b63be9b0371e788c$var$STRENGTH_LABELS.MEDIUM;
    if (length >= STRONG.min && length <= STRONG.max) return $b63be9b0371e788c$var$STRENGTH_LABELS.STRONG;
    return null;
};
/**
 * Gets evaluation boxes to activate based on strength
 * @param {string} strength - Strength label
 * @returns {Array} Array of box elements to activate
 */ const $b63be9b0371e788c$var$getActiveBoxes = (strength)=>{
    const { box1: box1, box2: box2, box3: box3, box4: box4 } = $b63be9b0371e788c$var$elements.evaluationBoxes;
    switch(strength){
        case $b63be9b0371e788c$var$STRENGTH_LABELS.TOO_WEAK:
            return [
                box1
            ];
        case $b63be9b0371e788c$var$STRENGTH_LABELS.WEAK:
            return [
                box1,
                box2
            ];
        case $b63be9b0371e788c$var$STRENGTH_LABELS.MEDIUM:
            return [
                box1,
                box2,
                box3
            ];
        case $b63be9b0371e788c$var$STRENGTH_LABELS.STRONG:
            return [
                box1,
                box2,
                box3,
                box4
            ];
        default:
            return [];
    }
};
/**
 * Gets CSS classes for strength level
 * @param {string} strength - Strength label
 * @returns {Array} CSS classes
 */ const $b63be9b0371e788c$var$getStrengthClasses = (strength)=>{
    switch(strength){
        case $b63be9b0371e788c$var$STRENGTH_LABELS.TOO_WEAK:
            return $b63be9b0371e788c$var$CSS_CLASSES.fullEvalBoxTooWeak;
        case $b63be9b0371e788c$var$STRENGTH_LABELS.WEAK:
            return $b63be9b0371e788c$var$CSS_CLASSES.fullEvalBoxWeak;
        case $b63be9b0371e788c$var$STRENGTH_LABELS.MEDIUM:
            return $b63be9b0371e788c$var$CSS_CLASSES.fullEvalBoxMedium;
        case $b63be9b0371e788c$var$STRENGTH_LABELS.STRONG:
            return $b63be9b0371e788c$var$CSS_CLASSES.fullEvalBoxStrong;
        default:
            return [];
    }
};
// ============================================
// UI Update Functions
// ============================================
/**
 * Updates the range input track fill
 * @param {number} value - Current range value
 */ const $b63be9b0371e788c$var$updateRangeTrack = (value)=>{
    const { MIN: MIN, MAX: MAX } = $b63be9b0371e788c$var$CONFIG.PASSWORD_LENGTH;
    const percentage = (value - MIN) / (MAX - MIN) * 100;
    $b63be9b0371e788c$var$elements.lengthInput.style.background = `linear-gradient(to right, #a4ffaf 0%, #a4ffaf ${percentage}%, #18171f ${percentage}%, #18171f 100%)`;
    $b63be9b0371e788c$var$elements.lengthOutput.textContent = value;
};
/**
 * Resets all evaluation boxes to empty state
 */ const $b63be9b0371e788c$var$resetEvaluationBoxes = ()=>{
    $b63be9b0371e788c$var$elements.evaluationBoxes.all.forEach((box)=>{
        // Remove all strength classes
        box.classList.remove(...$b63be9b0371e788c$var$CSS_CLASSES.fullEvalBoxTooWeak, ...$b63be9b0371e788c$var$CSS_CLASSES.fullEvalBoxWeak, ...$b63be9b0371e788c$var$CSS_CLASSES.fullEvalBoxMedium, ...$b63be9b0371e788c$var$CSS_CLASSES.fullEvalBoxStrong);
        // Add empty classes
        box.classList.add(...$b63be9b0371e788c$var$CSS_CLASSES.emptyEvalBox);
    });
};
/**
 * Updates strength evaluation display
 * @param {number} length - Password length
 */ const $b63be9b0371e788c$var$updateStrengthEvaluation = (length)=>{
    const strength = $b63be9b0371e788c$var$getPasswordStrength(length);
    // Reset boxes first
    $b63be9b0371e788c$var$resetEvaluationBoxes();
    if (!strength) {
        $b63be9b0371e788c$var$elements.strengthEvaluationText.textContent = "";
        return;
    }
    // Update text
    $b63be9b0371e788c$var$elements.strengthEvaluationText.textContent = strength;
    // Update boxes
    const activeBoxes = $b63be9b0371e788c$var$getActiveBoxes(strength);
    const strengthClasses = $b63be9b0371e788c$var$getStrengthClasses(strength);
    activeBoxes.forEach((box)=>{
        box.classList.remove(...$b63be9b0371e788c$var$CSS_CLASSES.emptyEvalBox);
        box.classList.add(...strengthClasses);
    });
};
/**
 * Displays error message
 */ const $b63be9b0371e788c$var$showError = ()=>{
    $b63be9b0371e788c$var$elements.optionError.classList.remove($b63be9b0371e788c$var$CSS_CLASSES.hidden);
    $b63be9b0371e788c$var$elements.passwordNum.classList.add($b63be9b0371e788c$var$CSS_CLASSES.hidden);
};
/**
 * Hides error message
 */ const $b63be9b0371e788c$var$hideError = ()=>{
    $b63be9b0371e788c$var$elements.passwordNum.classList.remove($b63be9b0371e788c$var$CSS_CLASSES.hidden);
    $b63be9b0371e788c$var$elements.optionError.classList.add($b63be9b0371e788c$var$CSS_CLASSES.hidden);
};
/**
 * Shows "COPIED" message temporarily
 */ const $b63be9b0371e788c$var$showCopiedMessage = ()=>{
    // Clear existing timeout if any
    if ($b63be9b0371e788c$var$state.copiedTimeoutId) clearTimeout($b63be9b0371e788c$var$state.copiedTimeoutId);
    $b63be9b0371e788c$var$elements.copiedText.classList.remove($b63be9b0371e788c$var$CSS_CLASSES.hidden);
    // Auto-hide after configured duration
    $b63be9b0371e788c$var$state.copiedTimeoutId = setTimeout(()=>{
        $b63be9b0371e788c$var$elements.copiedText.classList.add($b63be9b0371e788c$var$CSS_CLASSES.hidden);
        $b63be9b0371e788c$var$state.copiedTimeoutId = null;
    }, $b63be9b0371e788c$var$CONFIG.COPIED_MESSAGE_DURATION);
};
/**
 * Resets all checkboxes
 */ const $b63be9b0371e788c$var$resetCheckboxes = ()=>{
    $b63be9b0371e788c$var$elements.checkboxes.all.forEach((checkbox)=>{
        checkbox.checked = false;
    });
};
/**
 * Resets the entire UI to initial state
 */ const $b63be9b0371e788c$var$resetUI = ()=>{
    $b63be9b0371e788c$var$elements.passwordNum.textContent = "";
    $b63be9b0371e788c$var$elements.strengthEvaluationText.textContent = "";
    $b63be9b0371e788c$var$elements.lengthInput.value = $b63be9b0371e788c$var$CONFIG.PASSWORD_LENGTH.DEFAULT;
    $b63be9b0371e788c$var$elements.lengthOutput.textContent = $b63be9b0371e788c$var$CONFIG.PASSWORD_LENGTH.DEFAULT;
    $b63be9b0371e788c$var$elements.copiedText.classList.add($b63be9b0371e788c$var$CSS_CLASSES.hidden);
    $b63be9b0371e788c$var$resetCheckboxes();
    $b63be9b0371e788c$var$resetEvaluationBoxes();
    $b63be9b0371e788c$var$hideError();
    $b63be9b0371e788c$var$updateRangeTrack($b63be9b0371e788c$var$CONFIG.PASSWORD_LENGTH.DEFAULT);
};
// ============================================
// Core Functions
// ============================================
/**
 * Generates and displays password
 */ const $b63be9b0371e788c$var$generatePassword = ()=>{
    const length = parseInt($b63be9b0371e788c$var$elements.lengthInput.value, 10);
    // Validate length
    if (isNaN(length) || length < $b63be9b0371e788c$var$CONFIG.PASSWORD_LENGTH.MIN) {
        $b63be9b0371e788c$var$resetUI();
        return;
    }
    // Handle zero length
    if (length === 0) {
        $b63be9b0371e788c$var$resetUI();
        return;
    }
    // Update strength evaluation
    $b63be9b0371e788c$var$updateStrengthEvaluation(length);
    // Build character pool
    const characterPool = $b63be9b0371e788c$var$buildCharacterPool();
    // Check if at least one checkbox is selected
    if (characterPool === "") {
        $b63be9b0371e788c$var$showError();
        $b63be9b0371e788c$var$resetEvaluationBoxes();
        $b63be9b0371e788c$var$elements.strengthEvaluationText.textContent = "";
        $b63be9b0371e788c$var$state.currentPassword = "";
        return;
    }
    // Generate password
    try {
        const password = $b63be9b0371e788c$var$generateSecurePassword(length, characterPool);
        $b63be9b0371e788c$var$state.currentPassword = password;
        // Display password
        $b63be9b0371e788c$var$hideError();
        $b63be9b0371e788c$var$elements.passwordNum.textContent = password;
    } catch (error) {
        console.error("Error generating password:", error);
        $b63be9b0371e788c$var$showError();
    }
};
/**
 * Copies password to clipboard
 */ const $b63be9b0371e788c$var$copyPasswordToClipboard = async ()=>{
    // Check if there's a password to copy
    if (!$b63be9b0371e788c$var$state.currentPassword) return;
    try {
        // Modern Clipboard API
        await navigator.clipboard.writeText($b63be9b0371e788c$var$state.currentPassword);
        $b63be9b0371e788c$var$showCopiedMessage();
    } catch (error) {
        // Fallback for older browsers
        try {
            const textArea = document.createElement("textarea");
            textArea.value = $b63be9b0371e788c$var$state.currentPassword;
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand("copy");
            document.body.removeChild(textArea);
            $b63be9b0371e788c$var$showCopiedMessage();
        } catch (fallbackError) {
            console.error("Failed to copy password:", fallbackError);
            alert("Failed to copy password. Please try again.");
        }
    }
};
// ============================================
// Event Handlers
// ============================================
/**
 * Handles range input changes
 */ const $b63be9b0371e788c$var$handleRangeInput = (event)=>{
    const value = parseInt(event.target.value, 10);
    if (!isNaN(value)) $b63be9b0371e788c$var$updateRangeTrack(value);
};
/**
 * Handles generate button click
 */ const $b63be9b0371e788c$var$handleGenerateClick = ()=>{
    $b63be9b0371e788c$var$generatePassword();
};
/**
 * Handles copy image click
 */ const $b63be9b0371e788c$var$handleCopyClick = ()=>{
    $b63be9b0371e788c$var$copyPasswordToClipboard();
};
/**
 * Handles keyboard events for accessibility
 */ const $b63be9b0371e788c$var$handleKeyboardCopy = (event)=>{
    // Copy on Enter or Space when focused on copy button
    if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        $b63be9b0371e788c$var$copyPasswordToClipboard();
    }
};
// ============================================
// Event Listeners Setup
// ============================================
const $b63be9b0371e788c$var$setupEventListeners = ()=>{
    // Range input
    $b63be9b0371e788c$var$elements.lengthInput.addEventListener("input", $b63be9b0371e788c$var$handleRangeInput);
    // Generate button
    $b63be9b0371e788c$var$elements.generateButton.addEventListener("click", $b63be9b0371e788c$var$handleGenerateClick);
    // Copy functionality
    $b63be9b0371e788c$var$elements.copyImage.addEventListener("click", $b63be9b0371e788c$var$handleCopyClick);
    $b63be9b0371e788c$var$elements.copyImage.addEventListener("keydown", $b63be9b0371e788c$var$handleKeyboardCopy);
};
// ============================================
// App Initialization
// ============================================
const $b63be9b0371e788c$var$App = {
    init () {
        try {
            // Validate DOM elements
            $b63be9b0371e788c$var$validateDOMElements();
            //Configure range input from CONFIG
            $b63be9b0371e788c$var$elements.lengthInput.min = $b63be9b0371e788c$var$CONFIG.PASSWORD_LENGTH.MIN;
            $b63be9b0371e788c$var$elements.lengthInput.max = $b63be9b0371e788c$var$CONFIG.PASSWORD_LENGTH.MAX;
            $b63be9b0371e788c$var$elements.lengthInput.value = $b63be9b0371e788c$var$CONFIG.PASSWORD_LENGTH.DEFAULT;
            // Setup event listeners
            $b63be9b0371e788c$var$setupEventListeners();
            // Initialize UI
            $b63be9b0371e788c$var$resetUI();
            console.log("Password Generator initialized successfully");
        } catch (error) {
            console.error("Failed to initialize app:", error);
            alert("Failed to initialize the password generator. Please refresh the page.");
        }
    }
};
// Start the application when DOM is ready
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ()=>$b63be9b0371e788c$var$App.init());
else $b63be9b0371e788c$var$App.init();


//# sourceMappingURL=repo.30a31a8f.js.map
